import api from "./index";

export async function getRanking(params) {
  return api.get("/ranking", { params });
}
